module.exports = __webpack_public_path__ + "av.no1.11ba039f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/av.no1.jpg
// module id = 8nJ7
// module chunks = 0